// Assessment overview section questionnaire constants
export enum AssessmentOverviewQuestionnaireItem {
  ASSESSMENT_OVERVIEW = 'assessment-overview',
  ASSESSMENT_OVERVIEW_APPOINTMENT_TIME = 'assessment-overview/appointment-time',
  ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START = 'assessment-overview/appointment-time/start',
  ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END = 'assessment-overview/appointment-time/end'
}
